import * as React from 'react';
import ITable from './ITable';

// Component moved from old TransactionsApp

import * as style from './TableStyles.module.scss'

const Table: React.FunctionComponent<ITable> = (props) => {

  const renderHeaders = () => props.headers.map((header:string) => {
    return <th key={header} className={style.header}>{header}</th>;
  });

  return (
    <table className={style.table}>
      <thead className={style.header}>
        <tr>
          {renderHeaders()}
        </tr>
      </thead>
      <tbody>
        {props.children}
      </tbody>
    </table>
  );
};

export default Table;
